import { PlayerWeapons } from "../../GameConfig/PlayerConfig.js";
import Weapon from "./weapon.js";

export default class CannonBullet extends Weapon {
  constructor(game) {
    super();
    this.game = game;

    this.y = this.game.player.y + this.game.player.spriteHeight / 2;

    this.image.src = PlayerWeapons.CannonBullet.IMG_SRC;
    this.spriteWidth = PlayerWeapons.CannonBullet.SPRITE_WIDTH;
    this.spriteHeight = PlayerWeapons.CannonBullet.SPRITE_HEIGHT;

    this.speed = PlayerWeapons.CannonBullet.SPEED;
    this.damage = PlayerWeapons.CannonBullet.DAMAGE;
  }
}
